import { gql } from "@apollo/client";

export const getCorporateDivisionsRegionsMills = gql`
    query getCorporateDivisionsRegionsMills {
        corporate {
            corporate_id
            rca_enabled
            corporate_dashboard_enabled
            media {
                media_id
                media_url
            }
            divisions {
                division_id
                name
                regions {
                    region_id
                    name
                    mills {
                        mill_id
                        name
                    }
                }
            }
            mills(limit: 2) {
                mill_id
            }
        }
        mill(where: { division_id: { _is_null: true } }) {
            mill_id
            name
        }
    }
`;
